import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { InjuryDetailsReport } from './Pages'

export const InjuryDetailsReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={InjuryDetailsReport} />
    </Fragment>
)